import { Component, OnDestroy, ViewChild } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'

import { EventsEmitterService } from '../../services/events-emitter.service'
import { GroupsService } from '../../services/groups.service'
import { UsersService } from '../../services/users.service'
import { MessagesDelegate } from '../../services/messages-delegate.service'
import { EventsService } from '../../services/events.service'

import { Group } from '../../models/group.model'
import { Event } from '../../models/event.model'

@Component({
  selector: 'ld-group',
  template: require('./group.component.html'),
  styles: [require('./group.component.css')]
})
export class GroupComponent implements OnDestroy {

  @ViewChild('userFormComponent') userFormComponent
  private group = new Group()
  private events: Event[] = []
  private editing$
  private routingSub
  private isMember = false

  constructor (
    private eventsEmitterService: EventsEmitterService,
    private route: ActivatedRoute,
    private groupsService: GroupsService,
    private usersService: UsersService,
    private eventsService: EventsService,
    private messagesDelegate: MessagesDelegate,
    private router: Router) {
    this.editing$ = this.eventsEmitterService.listen('editing')
    this.routingSub = this.route.params.subscribe(this.onRouting.bind(this))
  }

  ngOnDestroy () {
    this.routingSub.unsubscribe()
  }

  async onRouting (params) {
    try {
      this.group = await this.groupsService.getById(params.id)
      this.events = await this.eventsService.find({ groupId: this.group.id })
    } catch (err) {
      this.messagesDelegate.add(err.status === 404 ? 'APP.GROUP.NOT_FOUND' : err.message, true)
      return
    }

    if (this.usersService.currentUser.isAdmin() || this.usersService.currentUser.id === this.group.author.id) {
      this.eventsEmitterService.emit('showAdminMenu', true)
    }

    this.isMember = !!this.group.users.find((u) => u.id === this.usersService.currentUser.id)
  }

  async joinGroup () {
    this.group = await this.groupsService.addUser({
        id: this.group.id,
        userId: this.usersService.currentUser.id
      })
      .catch((e) => {
        this.messagesDelegate.add(e.message)
        return this.group
      })

    this.messagesDelegate.add('APP.GROUP.JOINED')
    this.isMember = true
  }

  async leaveGroup () {
    this.group = await this.groupsService.deleteUser(this.group.id, this.usersService.currentUser.id)
      .catch((e) => {
        this.messagesDelegate.add(e.message)
        return this.group
      })

    this.messagesDelegate.add('APP.GROUP.LEAVED')
    this.isMember = false
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/group/group.component.ts